const money = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });
const percent = new Intl.NumberFormat('en-AU', { style: 'percent', maximumFractionDigits: 2 });

/** Keep missing chart values distinct from zero, and format ratios without changing their scale. */
export function formatRmTooltipValue(value: unknown, isPercent = false): string {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return 'Unknown';
  }
  return (isPercent ? percent : money).format(value);
}
